import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../utils/api';
import { formatTimeLocale } from '../../utils/i18nHelpers';
import { useNotification } from '../../contexts/NotificationContext';
import ProtectedRoute from '../../components/ProtectedRoute';
import AdminLayout, { useTheme } from '../../components/AdminLayout';
import Skeleton from '../../components/Skeleton';

function BookingsContent() {
  const { t, i18n } = useTranslation();
  const { showAlert } = useNotification();
  const { T, S } = useTheme();
  const locale = i18n.language === 'ar' ? 'ar-EG' : 'en-GB';
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookings = async () => {
    try { const data = await api.getManagerBookings(); setBookings(data); }
    catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchBookings(); }, []);

  const setStatus = async (id, status) => {
    try { await api.updateManagerBooking(id, { status }); fetchBookings(); }
    catch (err) { showAlert(err.message); }
  };

  return (
    <AdminLayout role="manager">
      <div style={{ marginBottom: '2rem' }}>
        <h1 style={S.pageTitle}>{t('admin.bookings')}</h1>
        <div style={{ width: '40px', height: '2px', background: T.orange }} />
      </div>

      {loading ? <Skeleton count={5} height="48px" />
        : bookings.length === 0 ? <p style={{ color: T.muted }}>{t('manager.noBookings')}</p>
          : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
              {bookings.map(b => (
                <div key={b.id} style={{ ...S.card, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
                  <div>
                    <h3 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: T.white, marginBottom: '0.4rem' }}>
                      {b.service_name}
                    </h3>
                    <p style={{ fontSize: '0.82rem', color: T.muted }}>📅 {b.booking_date} at {formatTimeLocale(b.booking_time, locale)}</p>
                    <p style={{ fontSize: '0.82rem', color: T.muted }}>💰 {b.service_price} EGP</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <span style={S.badge(b.status)}>{t(`booking.status.${b.status}`, b.status)}</span>
                    {b.status !== 'confirmed' && b.status !== 'no_show' && b.status !== 'cancelled' && (
                      <button style={S.btnSmall} onClick={() => setStatus(b.id, 'confirmed')}
                        onMouseEnter={e => e.target.style.color = T.greenText}
                        onMouseLeave={e => e.target.style.color = T.muted}>{t('admin.confirm')}</button>
                    )}
                    {b.status === 'confirmed' && (
                      <button style={{ ...S.btnSmall, color: '#fdba74' }} onClick={() => setStatus(b.id, 'no_show')}
                        onMouseEnter={e => e.target.style.color = '#f97316'}
                        onMouseLeave={e => e.target.style.color = '#fdba74'}>{t('booking.noShow', 'No Show')}</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
    </AdminLayout>
  );
}

export default function Bookings() {
  return <ProtectedRoute requireSalonManager><BookingsContent /></ProtectedRoute>;
}
